module.exports = __webpack_public_path__ + "images/cinephile-ffafdf638b93d89031a1aaa6d04d66ea.png";